import { render } from "./WhatToDoPage.vue?vue&type=template&id=ffd889e4&scoped=true"
import script from "./WhatToDoPage.vue?vue&type=script&lang=js"
export * from "./WhatToDoPage.vue?vue&type=script&lang=js"

import "./WhatToDoPage.vue?vue&type=style&index=0&id=ffd889e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd889e4"]])

export default __exports__